import React from "react";
import classes from "./Spinner.module.scss";

const Spinner = (className = "", small = false, center = null, key=undefined) => {
  let finalClass = className + " " + classes.SpinnerArea;
  if (small) finalClass += " " + classes.Small;
  if (center) finalClass += " " + classes.Center;

  return (
    <div className={finalClass} key={(key)?key:'spinner'}>
      <div className={classes.Spinner}></div>
    </div>
  );
};

export default Spinner;
